import { setAuthSessionItem, clearAuthSession } from "utils/authSession";
import { formatAbn } from "utils/abn";
import RctiEligibility from "components/RctiEligibility";
import { verifyAbrAbn } from "utils/abrAPI";
import "layouts/RCTI/agreements.css";
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";

import { Delete, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import backgroundImage from "assets/images/bg-profile.jpg";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import Auto from "components/AutoComplete/AutoComplete";
import MDButton from "components/MDButton";
import MuiPhoneNumber from "material-ui-phone-number";
import Cropper from "react-easy-crop";
import { useDispatch, useSelector } from "react-redux";
import { deleteUserProfile, deactivateUserProfile } from "utils/api";
import { genericMessage } from "utils/genericMessages";
import { useNavigate } from "react-router-dom";
import { getUserProfileByID, updateUserProfileByID } from "utils/api";
import { appConstants } from "utils/appConstants";
import {
  generateDataList,
  handleStreetAddress,
  showResMsg,
  validateField,
} from "utils/generic";
import empty from "../../../assets/images/empty.png";
import "./editProfilr.scss";
import DeactiveDeleteModal from "components/displayModel/DeactiveDeleteModal";
import ConfirmPasswordModal from "components/displayModel/confirmPasswordModal";
import Swal from "sweetalert2";

const cropContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: "80px",
};

const actualImg = {
  height: "96px",
  width: "96px",
};

const uploadSpace = {
  width: "96px",
  height: "96px",
  borderRadius: "50%",
  background: "var(--surface-subtle, #f4f7f6)",
  border: "1px solid var(--border-subtle, #dce3e2)",
  overflow: "hidden",
};
const style = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
};

let id = undefined;
let fetchedUserProfile = {};
let myfile;
let Name;
let masterUserType;

function MyProfile() {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  let mandateFlag = false;
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErrErr] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [savedAbn, setSavedAbn] = useState("");
  const [abrBusy, setAbrBusy] = useState(false);
  const [abrResult, setAbrResult] = useState(null);
  const [abrError, setAbrError] = useState("");
  const abrRequest = useRef(0);
  const [abnNumberErr, setAbnNumberErr] = useState(false);
  const [abnNumberErrMsg, setAbnNumberErrMsg] = useState("");

  const [companyNameErr, setCompanyNameErr] = useState(false);
  const [phoneNumbmerErr, setPhoneNumbmerErr] = useState(false);
  const [phoneNumbmerErrMsg, setPhoneNumbmerErrMsg] = useState("");
  const [organizationTypeErr, setOrganizationTypeErr] = useState(false);
  const [industryTypeErr, setIndustryTypeErr] = useState(false);
  const [actualFile, setActualFile] = useState();
  const [fileName, setFileName] = useState("");

  const [deletePPFlag, setDeletePPFlag] = useState(false);
  const [newPasswordErr, setNewPasswordErr] = useState(false);
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [newPasswordErrMsg, setNewPasswordErrMsg] = useState("");
  const [confirmPasswordErrMsg, setConfirmPasswordErrMsg] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentPasswordErr, setCurrentPasswordErr] = useState(false);
  const [currentPasswordErrMsg, setCurrentPasswordErrMsg] = useState("");
  let navigate = useNavigate();
  const requestedReturnTo = new URLSearchParams(window.location.search).get(
    "returnTo"
  );
  const invoiceReturnTo = requestedReturnTo === "/rcti-agreements" || requestedReturnTo?.startsWith("/invoices/add")
    ? requestedReturnTo
    : "";
  const focusBanking =
    new URLSearchParams(window.location.search).get("focus") === "banking";
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!focusBanking) return undefined;
    const timeout = window.setTimeout(() => {
      const input = document.getElementById("profile-bank-account-name");
      input?.scrollIntoView({ behavior: "smooth", block: "center" });
      input?.focus({ preventScroll: true });
    }, 250);
    return () => window.clearTimeout(timeout);
  }, [focusBanking]);

  // ==============For Crop Image Start==============
  const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [file1, setFile1] = useState();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [file, setFile] = useState(() => {
    try {
      const u = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS") || "{}");
      const pic =
        u.profilePictureFileName || u.profilePicFileName || u.profileImage;
      if (
        pic &&
        typeof pic === "string" &&
        pic.trim() &&
        pic !== "null" &&
        pic !== "undefined" &&
        pic !== "empty"
      ) {
        const trimmed = pic.trim();
        if (
          trimmed.startsWith("http://") ||
          trimmed.startsWith("https://") ||
          trimmed.startsWith("data:") ||
          trimmed.startsWith("blob:")
        ) {
          return trimmed;
        }
        return `${
          appConstants.baseURL
        }user/viewFile?fileName=${encodeURIComponent(trimmed)}`;
      }
    } catch {}
    return "";
  });
  const [fileError, setFileError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const dispatch = useDispatch();
  let countryData = useSelector(
    (state) => state.countryState.countryStateMenu.country
  );
  let stateData = useSelector(
    (state) => state.countryState.countryStateMenu.state
  );

  // ==============For Deactivate or Delete
  const [showDeactiveDeleteModal, setShowDeactiveDeleteModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [titleMsg, setTitleMsg] = useState("");
  const [modalMsg, setModalMsg] = useState("");
  const [notesMsg, setNotesMsg] = useState("");
  const [showConfirmPasswordModal, setShowConfirmPasswordModal] =
    useState(false);
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  if (
    sessionStorage.getItem("USER_ID") != undefined ||
    sessionStorage.getItem("USER_ID") != null
  ) {
    id = sessionStorage.getItem("USER_ID").replaceAll('"', "");
  }

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCropedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(file1, croppedAreaPixels);
      setActualFile(croppedImage);
      setFile(croppedImage);
      setFileError(false);
      myfile = await fetch(croppedImage)
        .then((r) => r.blob())
        .then(
          (blobFile) =>
            new File([blobFile], actualFile.name, { type: "image/png" })
        );
      setFileName(actualFile.name);
      setDeletePPFlag(false);
      setOpenCropImageModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const handleCropCancel = async () => {
    setOpenCropImageModal(false);
    setActualFile();
    setFileName("");
    setFile1();
    setDynamicAspect(1 / 1);
  };

  const saveFile = (e) => {
    const selectedFile = e.target.files?.[0];
    e.target.value = "";
    if (!selectedFile) return;
    setOpenCropImageModal(true);
    setFile1(URL.createObjectURL(selectedFile));
    setActualFile(selectedFile);
    setFileName(selectedFile.name);
    setDeletePPFlag(false);
  };
  const [values, setValues] = React.useState({
    bankAccountName: "",
    bankAccountNumber: "",
    bankBsbCode: "",
    countryCode: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "+61",
    onlyPhoneNumber: "",
    zipCode: "",
    city: "",
    stateId: "",
    countryId: "",
    streetAddress: "",
    companyName: "",
    _id: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    abnNumber: "",
    industryType: "",
    organizationType: "",
    userStatus: "",
    isUserChild: false,
    businessUserID: loginDetails?.businessUserID,
  });

  console.log("abhi===========================", values.currentPassword);

  // for get current password

  const getCurrentPassword = () => {};
  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      // Numeric-only fields
      if (name === "bankAccountNumber") {
        let value = event.target.value.replace(/\D/g, "");
        if (value.length > 50) value = value.slice(0, 50); // max 50 digits
        setValues({ ...values, [name]: value });
        return;
      }

      if (name === "bankBsbCode") {
        let value = event.target.value.replace(/\D/g, "");
        if (value.length > 10) value = value.slice(0, 10); // max 10 digits
        setValues({ ...values, [name]: value });
        return;
      }
      if (name === "abnNumber") {
        let value = event.target.value.replace(/\D/g, "");

        if (name === "abnNumber") {
          value = value.slice(0, 11);

          if (value.length > 2) {
            value = value.slice(0, 2) + " " + value.slice(2);
          }
          if (value.length > 6) {
            value = value.slice(0, 6) + " " + value.slice(6);
          }
          if (value.length > 10) {
            value = value.slice(0, 10) + " " + value.slice(10);
          }
          setValues({ ...values, [name]: value });
        }
      } else
        setValues((prevValues) => ({
          ...prevValues,
          [name]: event.target.value,
        }));
    } else if (event.target.validity === undefined) {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: event.target.value,
      }));
    }
    if (name === "firstName" || name === "lastName") {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: event.target.value.replace(/\s+/g, " "),
      }));
    }
  };

  const handleChangeCheck = (event) => {
    setShowPassword(event.target.checked);
    if (!event.target.checked) {
      setNewPasswordErr(false);
      setConfirmPasswordErr(false);
      setValues((prevValues) => ({
        ...prevValues,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }));
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      values._id = id;
      initialLoad();
    }
  }, [values._id]);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    (async () => {
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
    })();
  }, []);

  const initialLoad = () => {
    getUserProfileByID(
      values,
      (data) => {
        if (data?.Result_Output?.length > 0) {
          fetchedUserProfile = data.Result_Output[0];
          if (fetchedUserProfile.userType === "Business") {
            masterUserType = fetchedUserProfile.userType;
          }
          Name =
            fetchedUserProfile.firstName + " " + fetchedUserProfile.lastName;
          fetchedUserProfile.onlyPhoneNumber = fetchedUserProfile.phoneNumber
            ? fetchedUserProfile.phoneNumber.slice(3).toString().trim()
            : "F";

          setValues(fetchedUserProfile);
          setSavedAbn(String(fetchedUserProfile.abnNumber || "").trim());

          const picFile =
            fetchedUserProfile.profilePictureFileName ||
            fetchedUserProfile.profilePicFileName;
          values.profilePictureFileName = picFile || "";

          if (
            picFile &&
            picFile !== "null" &&
            picFile !== "undefined" &&
            picFile !== "empty"
          ) {
            const trimmed = String(picFile).trim();
            if (
              trimmed.startsWith("http://") ||
              trimmed.startsWith("https://") ||
              trimmed.startsWith("data:") ||
              trimmed.startsWith("blob:")
            ) {
              setFile(trimmed);
            } else {
              setFile(
                `${
                  appConstants.baseURL
                }user/viewFile?fileName=${encodeURIComponent(trimmed)}`
              );
            }
            setFileError(false);
          }

          try {
            const userDetails = JSON.parse(
              sessionStorage.getItem("LOGIN_DETAILS") || "{}"
            );
            const merged = { ...userDetails, ...fetchedUserProfile };
            if (picFile) merged.profilePictureFileName = picFile;
            setAuthSessionItem("LOGIN_DETAILS", JSON.stringify(merged));
            window.dispatchEvent(new Event("user-profile-updated"));
          } catch {}
        }
      },
      dispatch
    );
  };
  const setPhoneValues = (phone, country) => {
    const countryCode = "+" + country.dialCode;
    const phoneNumber = phone
      .slice(country.dialCode.length + 1)
      .toString()
      .trim();
    values.onlyPhoneNumber = phoneNumber;
    values.phoneNumber = phone;
    values.countryCode = countryCode;
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: "",
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  };

  const IndustryOptions = [
    "Accommodation and food service",
    "Administrative and support services",
    "Agriculture, Forestry and Fishing",
    "Arts and recreation services",
    "Construction",
    "Education and Training",
    "Financial and Insurance",
    "Health care and social assistance",
    "Information media and telecommunications",
    "Manufacturing",
    "Mining",
    "Professional, scientific and technical services",
    "Rental, hiring and real estate services",
    "Retail and wholesale trade",
    "Tourism",
    "Transport, postal and warehousing",
  ];

  const clearErrState = () => {
    setFirstNameErr(false);
    setLastNameErrErr(false);
    setAbnNumberErr(false);
    setStreetAddressErr(false);
    setIndustryTypeErr(false);
    setOrganizationTypeErr(false);
    setPhoneNumbmerErr(false);
    setCompanyNameErr(false);
  };
  const checkBusinessAbn = async () => {
    const request = ++abrRequest.current;
    const abn = String(values.abnNumber || "").replace(/[\s-]/g, "");
    setAbrBusy(true); setAbrError(""); setAbrResult(null);
    try {
      const result = await verifyAbrAbn(abn);
      if (request !== abrRequest.current) return null;
      if (!result.active) throw new Error("This ABN is not active on ABR.");
      setAbrResult(result); return result;
    } catch (error) { if (request === abrRequest.current) setAbrError(error.message); return null; }
    finally { if (request === abrRequest.current) setAbrBusy(false); }
  };
  const updateUserProfile = async () => {
    try {
      mandateFlag = false;
      clearErrState();
      if (
        !values.onlyPhoneNumber ||
        values.onlyPhoneNumber.toString().trim() === ""
      ) {
        mandateFlag = true;
        setPhoneNumbmerErr(true);
        setPhoneNumbmerErrMsg("Mobile Number can't be blank");
      } else if (values.onlyPhoneNumber.toString().trim().length < 8) {
        mandateFlag = true;
        setPhoneNumbmerErr(true);
        setPhoneNumbmerErrMsg("Mobile Number is invalid");
      } else {
        mandateFlag = false;
        setPhoneNumbmerErr(false);
        setPhoneNumbmerErrMsg("");
      }
      mandateFlag =
        validateField(values.firstName, setFirstNameErr) || mandateFlag;
      mandateFlag =
        validateField(values.lastName, setLastNameErrErr) || mandateFlag;

      if (values.userType !== "Admin" && !values.isUserChild) {
        mandateFlag =
          validateField(values.industryType, setIndustryTypeErr) || mandateFlag;
        mandateFlag =
          validateField(values.organizationType, setOrganizationTypeErr) ||
          mandateFlag;
        mandateFlag =
          validateField(values.streetAddress, setStreetAddressErr) ||
          mandateFlag;
        mandateFlag =
          validateField(values.companyName, setCompanyNameErr) || mandateFlag;

        const abnNumber = values.abnNumber.toString().trim();
        // if (abnNumber) {
        //   if (!validateABN(abnNumber)) {
        //     showResMsg(genericMessage.invalidABN, 2000, false);
        //     mandateFlag = true;
        //   }
        // }
        // if (abnNumber.length === 0) {
        //   mandateFlag = true;
        //   setAbnNumberErr(true);
        //   setAbnNumberErrMsg("ABN Number can't be blank ");
        // }
        //  else if (abnNumber.length < 9) {
        //   mandateFlag = true;
        //   setAbnNumberErr(true);
        //   setAbnNumberErrMsg("ABN Number must be at least 9 digits ");
        // }
      }
      if (showPassword) {
        if (
          values.currentPassword === "" ||
          values.currentPassword === undefined
        ) {
          setCurrentPasswordErr(true);
          setShowPassword(true);
          setCurrentPasswordErrMsg("Current Password can't be blank");
          mandateFlag = true;
        }
        if (values.newPassword === "" || values.newPassword === undefined) {
          setNewPasswordErr(true);
          setShowPassword(true);
          setNewPasswordErrMsg("New Password can't be blank");
          mandateFlag = true;
        } else if (
          values.newPassword?.toString()?.trim().length < 8 ||
          values.newPassword?.toString()?.trim().length > 20
        ) {
          setNewPasswordErr(true);
          setNewPasswordErrMsg("Password should be between 8 to 20 characters");
          mandateFlag = true;
        } else if (!/[A-Z]/.test(values.newPassword)) {
          setNewPasswordErr(true);
          setNewPasswordErrMsg(
            "Password should contain at least one uppercase letter"
          );
          mandateFlag = true;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword)) {
          setNewPasswordErr(true);
          setNewPasswordErrMsg(
            "Password should contain at least one special character"
          );
          mandateFlag = true;
        } else setNewPasswordErr(false);

        if (
          values.confirmPassword === "" ||
          values.confirmPassword === undefined
        ) {
          setConfirmPasswordErr(true);
          setConfirmPasswordErrMsg("Confirm Password can't be blank");
          mandateFlag = true;
        } else if (
          values.newPassword.toString()?.trim() !==
          values.confirmPassword.toString()?.trim()
        ) {
          setConfirmPasswordErr(true);
          setConfirmPasswordErrMsg(
            "Confirm Password should be same as New Password"
          );
          mandateFlag = true;
        } else if (
          values.confirmPassword?.toString()?.trim().length < 8 ||
          values.confirmPassword?.toString()?.trim().length > 20
        ) {
          setConfirmPasswordErr(true);
          setConfirmPasswordErrMsg(
            "Password should be between 8 to 20 characters"
          );
          mandateFlag = true;
        } else if (!/[A-Z]/.test(values.newPassword)) {
          setConfirmPasswordErr(true);
          setConfirmPasswordErrMsg(
            "Password should contain at least one uppercase letter"
          );
          mandateFlag = true;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword)) {
          setConfirmPasswordErr(true);
          setConfirmPasswordErrMsg(
            "Password should contain at least one special character"
          );
          mandateFlag = true;
        } else setConfirmPasswordErr(false);
      }

      if (mandateFlag) {
        return;
      } else {
        if (!savedAbn && String(values.abnNumber || "").trim() && values.userType === "Business") {
          const abn = String(values.abnNumber).replace(/[\s-]/g, "");
          if (abrResult?.abn !== abn && !(await checkBusinessAbn())) return;
        }
        const formData = new FormData();
        for (const key of ["gstRegistered", "isLargeBusiness", "isGovernmentEntity"]) {
          if (typeof values[key] === "boolean") formData.append(key, String(values[key]));
          else if (values[key] === null) formData.append(key, "");
        }
        formData.append("deletePPFlag", deletePPFlag);
        formData.append("isbusinessUser", !values.isUserChild);
        formData.append("file", myfile);
        formData.append("fileName", fileName);
        formData.append("firstName", values.firstName);
        formData.append("lastName", values.lastName);
        formData.append("emailAddress", values.emailAddress);
        formData.append("phoneNumber", values.phoneNumber);
        formData.append("userType", values.userType);

        formData.append("_id", values._id);
        formData.append("profilePicFileName", values.profilePictureFileName);
        if (showPassword) {
          formData.append("currentPassword", values.currentPassword);
          formData.append("newPassword", values.newPassword);
          formData.append("confirmPassword", values.confirmPassword);
        }
        formData.append("companyName", values.companyName);
        formData.append("streetAddress", values.streetAddress);
        formData.append("city", values.city);
        formData.append("zipCode", values.zipCode);
        formData.append("stateId", values.stateId);
        formData.append("countryId", values.countryId);

        formData.append("abnNumber", values.abnNumber);
        formData.append("industryType", values.industryType);
        formData.append("organizationType", values.organizationType);

        if (
          values.bankAccountNumber !== undefined &&
          values.bankAccountNumber !== null
        ) {
          formData.append("bankAccountNumber", values.bankAccountNumber);
        }
        if (
          values.bankAccountName !== undefined &&
          values.bankAccountName !== null
        ) {
          formData.append("bankAccountName", values.bankAccountName);
        }
        if (values.bankBsbCode !== undefined && values.bankBsbCode !== null) {
          formData.append("bankBsbCode", values.bankBsbCode);
        }
        console.log("PassWordj", values.confirmPassword);

        setIsSubmitting(true);
        updateUserProfileByID(
          formData,
          (data) => {
            setIsSubmitting(false);
            if (data.Result_Status) {
              setSavedAbn(String(values.abnNumber || "").trim());
              let userDetails = JSON.parse(
                sessionStorage.getItem("LOGIN_DETAILS")
              );
              if (userDetails) {
                userDetails.firstName = values.firstName;
                userDetails.lastName = values.lastName;
                const savedProfilePicture =
                  data.Result_Output?.profilePictureFileName;
                if (savedProfilePicture !== undefined) {
                  userDetails.profilePictureFileName = savedProfilePicture;
                } else if (values.profilePictureFileName) {
                  userDetails.profilePictureFileName =
                    values.profilePictureFileName;
                }
                if (values.companyName) {
                  userDetails.companyName = values.companyName;
                }
                userDetails.bankAccountName = values.bankAccountName;
                userDetails.bankBsbCode = values.bankBsbCode;
                userDetails.bankAccountNumber = values.bankAccountNumber;
                setAuthSessionItem(
                  "LOGIN_DETAILS",
                  JSON.stringify(userDetails)
                );
                try {
                  window.dispatchEvent(new Event("user-profile-updated"));
                } catch {}
              }

              const duration = 2000; // Same as showResMsg duration

              if (data.Result_Output.passwordUpdated === true) {
                // Clear session storage after showing message
                showResMsg(genericMessage.updated, duration, true);

                setTimeout(() => {
                  clearAuthSession();
                  navigate("/login");
                }, duration);

                return; // stop further execution
              } else {
                if (values.userType === "Business") {
                  showResMsg(
                    genericMessage.updated,
                    2000,
                    data.Result_Status,
                    navigate,
                    invoiceReturnTo || "/dashboard"
                  );
                } else {
                  showResMsg(
                    genericMessage.updated,
                    2000,
                    data.Result_Status,
                    navigate,
                    "/dashboard-su"
                  );
                }
              }
            } else {
              showResMsg(data.Result_Message || "Unable to update your profile.", 2500, false);
            }
          },
          dispatch
        );
      }
    } catch (error) {
      setIsSubmitting(false);
      console.log("In Catch of updateUserProfile==", error);
    }
  };

  const cancelUserProfile = () => {
    if (invoiceReturnTo) {
      navigate(invoiceReturnTo === "/rcti-agreements" ? "/rcti-agreements" : "/invoices");
      return;
    }
    if (values.userType === "Business") {
      navigate("/dashboard");
    } else {
      navigate("/dashboard-su");
    }
  };
  const conditions = [
    {
      test:
        values.newPassword?.trim().length > 8 &&
        values.newPassword?.trim().length < 20,
      message: "Password should be between 8 to 20",
    },
    {
      test: /[A-Z]/.test(values.newPassword),
      message: "Atleast 1 Upper case ",
    },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword),
      message: "Atleast 1 special character",
    },
  ];
  const conditions2 = [
    {
      test:
        values.confirmPassword?.trim().length > 8 &&
        values.confirmPassword?.trim().length < 20,
      message: "Password should be between 8 to 20",
    },
    {
      test: /[A-Z]/.test(values.confirmPassword),
      message: "Atleast 1 Upper case ",
    },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/.test(values.confirmPassword),
      message: "Atleast 1 special character",
    },
  ];

  const handleDeactivateProfile = async () => {
    setShowDeactiveDeleteModal(true);
    setActionType(`Deactivate`);
    setTitleMsg(`Deactivate Your Account?`);
    setModalMsg(
      `Confirm that you want to Deactivate your account. This action will change your account to Inactive.`
    );
    setNotesMsg(
      "Note: Deactivating your account will also make any associated accounts inactive."
    );
  };

  const handleDeleteProfile = async () => {
    setShowDeactiveDeleteModal(true);
    setActionType(`Delete`);
    setTitleMsg(`Delete Your Account?`);
    setModalMsg(
      `Please confirm that you want to delete your account. This action will send a request to the admin to delete all associated data.`
    );
    setNotesMsg(
      `Note: Before requesting deletion, the account will be deactivated. Please confirm to deactivate.`
    );
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    setShowDeactiveDeleteModal(false);
    setShowConfirmPasswordModal(false);
  };
  const deleteAccountRequest = async (payload) => {
    deleteUserProfile(
      payload,
      (res) => {
        showResMsg(res.Result_Message, 2000, res.Result_Status);
        if (res.Result_Status) {
          let timerInterval;
          Swal.fire({
            title:
              "<span style='font-size: 14px;'>Account Delete Request is being processed successfully</span>",
            html: "<span style='font-size: 12px;'>You are going to log out in <b></b> seconds.</span>",
            timer: 3000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const timer = Swal.getPopup().querySelector("b");
              timerInterval = setInterval(() => {
                timer.textContent = `${Swal.getTimerLeft()}`;
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              clearAuthSession();
              navigate("/login");
            }
          });
        }
      },
      dispatch
    );
  };
  const deactivateAccount = async (payload) => {
    deactivateUserProfile(
      payload,
      (res) => {
        showResMsg(res.Result_Message, 2000, res.Result_Status);
        if (res.Result_Status) {
          setShowConfirmPasswordModal(false);
          if (actionType === "Delete") {
            deleteAccountRequest(payload);
          } else {
            // initialLoad();
            clearAuthSession();
            navigate("/login");
          }
        }
      },
      dispatch
    );
  };
  const handleConfirm = async () => {
    const payload = {
      userID: id,
      businessUserID: values.businessUserID,
      businessUserName: values.firstName + " " + values.lastName,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
      actionType: actionType,
    };
    setShowDeactiveDeleteModal(false);
    if (values.userStatus === "Inactive") {
      setShowConfirmPasswordModal(false);
      deleteAccountRequest(payload);
    } else {
      actionType === "Delete" &&
        showResMsg("Password required to deactivate your account", 2000, false);
      setShowConfirmPasswordModal(true);
    }
  };

  const handleConfirmDeactivate = async (
    enteredPassword,
    enteredReason,
    actionType
  ) => {
    let payload = {
      userID: id,
      businessUserID: values.businessUserID,
      businessUserName: values.firstName + " " + values.lastName,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
      password: enteredPassword,
      reason: enteredReason,
      actionType: actionType,
    };
    deactivateAccount(payload);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox position="relative" mb={5}>
        <MDBox
          display="flex"
          alignItems="center"
          position="relative"
          minHeight="18.75rem"
          borderRadius="xl"
          sx={{
            backgroundImage: ({
              functions: { rgba, linearGradient },
              palette: { gradients },
            }) =>
              `${linearGradient(
                rgba(gradients.info.main, 0.6),
                rgba(gradients.info.state, 0.6)
              )}, url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "50%",
            overflow: "hidden",
          }}
        />
        <Card
          sx={{
            position: "relative",
            mt: -8,
            mx: 3,
            py: 5,
            px: 2,
          }}
        >
          <Grid container spacing={2} alignItems="center" px={3}>
            <Grid item>
              <MDBox style={uploadSpace}>
                <MDBox style={actualImg}>
                  {file && !fileError ? (
                    <img
                      src={file}
                      alt="Profile"
                      crossOrigin="anonymous"
                      onError={() => setFileError(true)}
                      style={{
                        width: "96px",
                        height: "96px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "96px",
                        height: "96px",
                        borderRadius: "50%",
                        backgroundColor: "var(--interactive-soft, #f0f8f7)",
                        color: "var(--interactive-default, #0f766e)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "22px",
                        fontWeight: 600,
                        fontFamily:
                          'var(--font-family-primary, "Lexend", sans-serif)',
                        border: "2px solid var(--border-subtle, #dce3e2)",
                      }}
                    >
                      {(
                        `${values.firstName || ""} ${
                          values.lastName || ""
                        }`.trim() ||
                        values.companyName ||
                        loginDetails?.companyName ||
                        "IR"
                      )
                        .split(/\s+/)
                        .filter(Boolean)
                        .slice(0, 2)
                        .map((w) => w[0])
                        .join("")
                        .toUpperCase()}
                    </div>
                  )}
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item>
              <MDBox height="100%" lineHeight={1}>
                <MDTypography variant="h5" fontWeight="medium">
                  {Name}
                </MDTypography>
                <MDTypography
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JPG, PNG or WEBP. Your photo is cropped to a square.
                </MDTypography>
                <MDBox display="flex" flexWrap="wrap" gap={1} mt={1.5}>
                  <Button
                    component="label"
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{
                      color: "var(--interactive-default, #0f766e)",
                      borderColor: "var(--border-default, #c8d2d0)",
                      textTransform: "none",
                    }}
                  >
                    {file && !fileError ? "Change photo" : "Upload photo"}
                    <input
                      hidden
                      type="file"
                      accept="image/png,image/jpeg,image/webp"
                      onChange={saveFile}
                    />
                  </Button>
                  {file && !fileError && (
                    <Button
                      variant="text"
                      size="small"
                      startIcon={<DeleteIcon fontSize="small" />}
                      onClick={() => {
                        setFile("");
                        setFileError(false);
                        setActualFile(null);
                        setFileName("");
                        setDeletePPFlag(true);
                        myfile = null;
                      }}
                      sx={{
                        color: "var(--danger-text, #b42318)",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "var(--danger-soft, #fff1f0)",
                        },
                      }}
                    >
                      Remove
                    </Button>
                  )}
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
          <Card
            sx={{
              boxShadow: "none",
              px: 3,
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} xl={12} lg={12}>
                <MDBox pb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    textTransform="capitalize"
                  >
                    My Profile
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <Grid container columnSpacing={4} rowSpacing={2}>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="text"
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[a-zA-Z ]+$",
                    maxLength: 30,
                  }}
                  value={values.firstName}
                  onChange={handleChange("firstName")}
                />
                {firstNameErr ? (
                  <span className="errMsg">First Name can't be blank</span>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="text"
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[a-zA-Z ]+$",
                    maxLength: 30,
                  }}
                  value={values.lastName}
                  onChange={handleChange("lastName")}
                />
                {lastNameErr ? (
                  <span className="errMsg">Last Name can't be blank</span>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="email"
                  label="Email Address (Username)"
                  variant="outlined"
                  inputProps={{
                    pattern: "^[a-zA-Z@. ]+$",
                    maxLength: 30,
                  }}
                  fullWidth
                  value={values.emailAddress}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MuiPhoneNumber
                  onlyCountries={["in", "au"]}
                  defaultCountry={"au"}
                  type="text"
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  value={values.phoneNumber}
                  onChange={(phone, country) => setPhoneValues(phone, country)}
                />
                {phoneNumbmerErr ? (
                  <span className="errMsg">{phoneNumbmerErrMsg}</span>
                ) : (
                  ""
                )}
              </Grid>

              {masterUserType === "Business" && !values.isUserChild && (
                <>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      id="profile-bank-account-name"
                      type="text"
                      label="Business Name"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        maxLength: 30,
                      }}
                      value={values.companyName}
                      onChange={handleChange("companyName")}
                    />
                    {companyNameErr ? (
                      <span className="errMsg">
                        Business Name can't be blank
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <Auto
                      onChange={handleStreetOnChange}
                      onPlaceSelected={(place, e) =>
                        handleStreetAddress(
                          place,
                          e,
                          (data) => {
                            setValues((prevValues) => ({
                              ...prevValues,
                              zipCode: data.zipCode,
                              city: data.city,
                              countryId: data.countryId,
                              stateId: data.stateId,
                              streetAddress: data.streetAddress,
                            }));
                          },
                          stateListRef,
                          countryListRef
                        )
                      }
                      value={values.streetAddress}
                    />

                    {streetAddressErr ? (
                      <span className="errMsg">
                        Street Address can't be blank
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="City"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        pattern: "^[a-zA-Z ]+$",
                        maxLength: 30,
                      }}
                      value={values.city}
                      onChange={handleChange("city")}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Zip Code"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 4,
                      }}
                      value={values.zipCode}
                      onChange={handleChange("zipCode")}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Country
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ minHeight: "44.11px" }}
                        label="Country"
                        disabled
                        value={values.countryId}
                        onChange={(e) =>
                          setValues({ ...values, countryId: e.target.value })
                        }
                      >
                        {country}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        State
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ minHeight: "44.11px" }}
                        label="State"
                        disabled
                        value={values.stateId}
                        onChange={(e) =>
                          setValues({ ...values, stateId: e.target.value })
                        }
                      >
                        {state}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Organization Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Organization Type"
                        style={{ height: "44.11px" }}
                        autoFocus={true}
                        onChange={handleChange("organizationType")}
                        value={values.organizationType}
                      >
                        <MenuItem value="">Select..</MenuItem>
                        <MenuItem value="Business">Business</MenuItem>
                        <MenuItem value="Individual">Individual</MenuItem>
                      </Select>
                    </FormControl>
                    {organizationTypeErr ? (
                      <span className="errMsg">
                        Please Select Organization Type
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="demo-simple-select-label">
                        Industry Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Industry Type"
                        style={{
                          minHeight: "30px",
                          height: "44.11px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200,
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            },
                          },
                        }}
                        autoFocus={true}
                        onChange={handleChange("industryType")}
                        value={values.industryType}
                      >
                        {/* {IndustryOptions.map((option, index) => (
                          <MenuItem key={index} value={option} >
                            
                            {option.length > 20 ? `${option.substring(0, 30)}.` : option}
                          </MenuItem>
                        ))} */}
                        {IndustryOptions.map((option, index) => (
                          <MenuItem
                            key={index}
                            value={option}
                            style={{
                              textOverflow:
                                values.industryType !== option
                                  ? "clip"
                                  : "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {option.length > 30 &&
                            values.industryType === option
                              ? `${option.substring(0, 30)}...`
                              : option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {industryTypeErr ? (
                      <span className="errMsg">
                        Please Select Industry Type
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="ABN Number"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[0-9 ]+$",
                      }}
                      autoComplete="off"
                      InputLabelProps={{ shrink: true }}
                      value={savedAbn ? formatAbn(values.abnNumber) : values.abnNumber}
                      onChange={event => { abrRequest.current += 1; setAbrResult(null); setAbrError(""); setAbrBusy(false); handleChange("abnNumber")(event); }}
                      InputProps={{ readOnly: Boolean(savedAbn) }}
                      helperText={savedAbn ? "Your ABN is saved and cannot be edited." : "Once saved, your ABN cannot be changed or removed."}
                    />
                    {abnNumberErr ? (
                      <span className="errMsg">{abnNumberErrMsg}</span>
                    ) : (
                      ""
                    )}
                    {!savedAbn && <button type="button" className="profile-abr-check" disabled={abrBusy || isSubmitting || !String(values.abnNumber || "").trim()} onClick={checkBusinessAbn}>{abrBusy ? "Checking ABR…" : "Verify ABN with ABR"}</button>}
                    {abrResult && <p role="status" className="profile-abr-success">Verified: {abrResult.companyName} · Active ABN</p>}
                    {abrError && <p role="alert" className="profile-abr-error">{abrError}</p>}
                  </Grid>

                  <Grid item xs={12}>
                    <RctiEligibility values={values} disabled={isSubmitting || abrBusy} onChange={(key, value) => setValues(current => ({ ...current, [key]: value }))} />
                    <p className="profile-eligibility-help">These RCTI eligibility settings can be updated when your business circumstances change.</p>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Bank Account Name"
                      variant="outlined"
                      placeholder="Bank Account Name"
                      fullWidth
                      name="Bank Account Name"
                      // disabled={id !== undefined}
                      inputProps={{
                        maxLength: 30,

                        autoComplete: "name",
                      }}
                      value={values.bankAccountName}
                      onChange={handleChange("bankAccountName")}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Bank BSB Code"
                      variant="outlined"
                      placeholder="Bank BSB Code"
                      fullWidth
                      name="Bank BSB Code"
                      // disabled={id !== undefined}
                      inputProps={{
                        maxLength: 10,
                        inputMode: "numeric", // mobile numeric keyboard
                        pattern: "[0-9]*", // only numbers allowed
                        autoComplete: "name",
                      }}
                      value={values.bankBsbCode}
                      onChange={handleChange("bankBsbCode")}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Bank Account Number"
                      variant="outlined"
                      placeholder="Bank Account Number"
                      fullWidth
                      name="Bank Account Number"
                      // disabled={id !== undefined}
                      inputProps={{
                        maxLength: 50,
                        autoComplete: "name",
                        inputMode: "numeric", // mobile numeric keyboard
                        pattern: "[0-9]*", // only numbers allowed
                      }}
                      value={values.bankAccountNumber}
                      onChange={handleChange("bankAccountNumber")}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} md={6} lg={3}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox onChange={handleChangeCheck} />}
                    checked={showPassword}
                    label="Change Password"
                  />
                </FormGroup>
              </Grid>

              {showPassword && (
                <>
                  {/* input form current password */}
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Current Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showCurrentPassword ? "text" : "password"}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") updateUserProfile();
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              {showCurrentPassword ? (
                                <VisibilityOff
                                  onClick={() =>
                                    setShowCurrentPassword(!showCurrentPassword)
                                  }
                                />
                              ) : (
                                <Visibility
                                  onClick={() =>
                                    setShowCurrentPassword(!showCurrentPassword)
                                  }
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        data-tooltip-id="passwordTooltip1"
                        value={values.currentPassword}
                        onChange={handleChange("currentPassword")}
                        label="Current Password"
                      />
                      <Tooltip
                        id="passwordTooltip1"
                        place="left"
                        effect="float"
                        border="1px solid #49a3f1"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                        }}
                      >
                        <ol
                          style={{
                            listStyleType: "none",
                            padding: 0,
                            margin: 0,
                            fontSize: "12px",
                          }}
                        >
                          {conditions.map((condition, index) => (
                            <li
                              key={index}
                              style={{
                                color: condition.test ? "green" : "gray",
                              }}
                            >
                              {condition.message}
                            </li>
                          ))}
                        </ol>
                      </Tooltip>
                      {currentPasswordErr ? (
                        <span className="errMsg">{currentPasswordErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        New Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showNewPassword ? "text" : "password"}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") updateUserProfile();
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              {showNewPassword ? (
                                <VisibilityOff
                                  onClick={() =>
                                    setShowNewPassword(!showNewPassword)
                                  }
                                />
                              ) : (
                                <Visibility
                                  onClick={() =>
                                    setShowNewPassword(!showNewPassword)
                                  }
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        data-tooltip-id="passwordTooltip1"
                        value={values.newPassword}
                        onChange={handleChange("newPassword")}
                        label="New Password"
                      />
                      <Tooltip
                        id="passwordTooltip1"
                        place="left"
                        effect="float"
                        border="1px solid #49a3f1"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                        }}
                      >
                        <ol
                          style={{
                            listStyleType: "none",
                            padding: 0,
                            margin: 0,
                            fontSize: "12px",
                          }}
                        >
                          {conditions.map((condition, index) => (
                            <li
                              key={index}
                              style={{
                                color: condition.test ? "green" : "gray",
                              }}
                            >
                              {condition.message}
                            </li>
                          ))}
                        </ol>
                      </Tooltip>
                      {newPasswordErr ? (
                        <span className="errMsg">{newPasswordErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Confirm Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showConfirmPassword ? "text" : "password"}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") updateUserProfile();
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                />
                              ) : (
                                <Visibility
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        data-tooltip-id="passwordTooltip"
                        label="Confirm Password"
                        value={values.confirmPassword}
                        onChange={handleChange("confirmPassword")}
                      />
                      <Tooltip
                        id="passwordTooltip"
                        place="left"
                        effect="float"
                        border="1px solid #49a3f1"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                        }}
                      >
                        <ol
                          style={{
                            listStyleType: "none",
                            padding: 0,
                            margin: 0,
                            fontSize: "12px",
                          }}
                        >
                          {conditions2.map((condition, index) => (
                            <li
                              key={index}
                              style={{
                                color: condition.test ? "green" : "gray",
                              }}
                            >
                              {condition.message}
                            </li>
                          ))}
                        </ol>
                      </Tooltip>
                      {confirmPasswordErr ? (
                        <span className="errMsg">{confirmPasswordErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid
              container
              mt={2}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
              rowSpacing={2}
            >
              <Grid item xs={12} md={4} spacing={2} lg={1.3}>
                <MDButton
                  onClick={cancelUserProfile}
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  disabled={isSubmitting || abrBusy}
                  fullWidth
                >
                  Close
                </MDButton>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.3}>
                <MDButton
                  onClick={updateUserProfile}
                  rel="noreferrer"
                  variant="gradient"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color="success"
                  fullWidth
                  loading={isSubmitting}
                  loadingLabel="Updating..."
                  disabled={isSubmitting || abrBusy}
                >
                  Update
                </MDButton>
              </Grid>
            </Grid>
          </Card>
        </Card>

        {/* Deactivate & Delete */}
        {values.userType !== "Admin" &&
          masterUserType === "Business" &&
          !values.isUserChild && (
            <>
              <Card sx={{ position: "relative", mt: 2, mx: 3, py: 5, px: 2 }}>
                <Grid sx={{ pb: 2 }}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    textTransform="capitalize"
                  >
                    Deactivating or Deleting your account
                  </MDTypography>
                </Grid>

                <Grid container>
                  <Grid item xs={6} md={6} lg={12}>
                    <MDTypography
                      fontWeight="small"
                      style={{ fontSize: "14px", lineHeight: "20px" }}
                    >
                      <b>Deactivating your account is temporary,</b> To
                      reactivate it, click "Forgot Password" on the login
                      screen, create a new password, and log in to activate your
                      account.
                    </MDTypography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={12}>
                    <MDTypography
                      fontWeight="small"
                      style={{ fontSize: "14px", lineHeight: "20px" }}
                    >
                      <b>Deleting your account is permanent.</b> A delete
                      request will be sent to the admin, who will proceed with
                      deleting your account.
                    </MDTypography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ pt: 2 }}>
                  <Grid item xs={6} md={6} lg={2.5}>
                    <MDButton
                      onClick={handleDeactivateProfile}
                      rel="noreferrer"
                      variant="gradient"
                      color="warning"
                      disabled={values.userStatus === "Inactive"}
                      fullWidth
                    >
                      Deactivate My Account
                    </MDButton>
                  </Grid>
                  <Grid item xs={6} md={6} lg={2.5}>
                    <MDButton
                      onClick={handleDeleteProfile}
                      rel="noreferrer"
                      variant="gradient"
                      color="error"
                      fullWidth
                    >
                      Delete My Account
                    </MDButton>
                  </Grid>
                </Grid>
              </Card>
              {showDeactiveDeleteModal && (
                <DeactiveDeleteModal
                  open={showDeactiveDeleteModal}
                  handleClose={handleClose}
                  handleConfirm={handleConfirm}
                  icon={actionType}
                  title={titleMsg}
                  notes={notesMsg}
                  message={modalMsg}
                />
              )}
              {showConfirmPasswordModal && (
                <ConfirmPasswordModal
                  open={showConfirmPasswordModal}
                  handleClose={handleClose}
                  handleConfirmDeactivate={handleConfirmDeactivate}
                  action={actionType}
                />
              )}
            </>
          )}

        {openCropImageModal && (
          <Modal
            open={openCropImageModal}
            onClose={() => {
              handleCropCancel();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={style}
          >
            <Grid className="crop-image-wrapper" id="modal-modal-title">
              <Grid
                container
                spacing={2}
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                <Grid style={cropContainer}>
                  <Cropper
                    image={file1}
                    crop={crop}
                    zoom={zoom}
                    aspect={dynamicAspect}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </Grid>
                <Grid container spacing={2} className="crop-control">
                  <Grid item>
                    <Typography
                      type="label"
                      style={{ color: "white", fontSize: "12px" }}
                    >
                      Aspect Ratio
                    </Typography>{" "}
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <select
                        onChange={(e) => {
                          return setDynamicAspect(parseFloat(e.target.value));
                        }}
                      >
                        <option>1/1</option>
                        <option value={"1.23"}>1.23/1</option>
                        <option value={"1.33"}>1.33/1</option>
                        <option value={"1.43"}>1.43/1</option>
                        <option value={"1.625"}>1.66/1</option>
                        <option value={"4.136/2"}>4/2</option>
                        <option value={"1.7"}>16/9</option>
                      </select>
                    </div>
                  </Grid>
                  <Grid item>
                    <Typography
                      type="label"
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      Zoom
                    </Typography>
                    &nbsp;
                    <input
                      type="range"
                      value={zoom}
                      min={1}
                      max={11}
                      step={0.1}
                      aria-labelledby="Zoom"
                      onChange={(e) => {
                        setZoom(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      className="modalButton cropimgbtn"
                      onClick={saveCropedImage}
                    >
                      Crop
                    </Button>
                  </Grid>
                  <Grid item style={{ cursor: "default", marginRight: "14px" }}>
                    <Button
                      className="modalButton crop-closebtn"
                      onClick={handleCropCancel}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Modal>
        )}
      </MDBox>
    </DashboardLayout>
  );
}

// Setting default props for the Header

export default MyProfile;
